import { MS_API_BACKEND_URL } from "../settings";
import { api } from "./api";

class ProductBaseMarginService {
  constructor() {
    this.url = `${MS_API_BACKEND_URL}/api/storage/v1/stock-rules/margins`;
  }

  async list(params) {
    return await api.get(this.url, { params });
  }

  async get(productBaseId) {
    return await api.get(`${this.url}/${productBaseId}`);
  }

  async save(productBaseId, data) {
    return await api.put(`${this.url}/${productBaseId}`, data);
  }

  async remove(productBaseId) {
    return await api.delete(`${this.url}/${productBaseId}`);
  }
}

const productBaseMarginService = new ProductBaseMarginService();
export default productBaseMarginService;
